module.exports = __webpack_public_path__ + "img/Amiri_ambushed-pathfinder.da4c4f82.jpg";